export default {
  blank: () => import("/srv/node/app/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/srv/node/app/layouts/default.vue").then(m => m.default || m)
}